import { stringify } from 'qs';
// import { Modal } from 'antd';
import api from '../config/api';
import eventBus from '../components/layout/Container/EventBus';
import { message } from '../components/biz';
import { network, generators, asserts, maths } from '../utils';
import { inventoryCal } from '../utils/biz';

// const { confirm } = Modal;
const { generatorObject } = generators;

// 判断 是否可以拆包
const pack = async (data) => {
  return await network({
    url: api.common.pack,
    method: 'post',
    data: stringify(data),
  });
};

// 加入购物车
const addToCart = async (data) => {
  //上报日志
  try {
    network.get(api.biLog.addLog, {
      params: {
        scene: '添加购物车',
        url: window.location.href,
      },
      silence: true,
    });
  } catch {}
  return await network({
    url: api.common.addToCart,
    method: 'post',
    data: stringify(data),
  });
};

//加入缺货购物车
// const shortageToCart = async (data) => {
//   return await network({
//     url: api.common.shortageAddToCart,
//     method: 'post',
//     data: stringify(data),
//   });
// };

/**
 * TODO: 收藏夹加车，由于收藏夹暂时用的以前写的，还未优化，所以用这个加车，和下边加车完全一样，写法不同
 */
const save = async (
  imitm,
  itemId,
  ibmcu,
  unitPcs,
  moq,
  itemQty,
  packFlag,
  index,
  dispatch,
  state,
) => {
  const addRes = await addToCart({
    imitm,
    itemId,
    spcomv: ibmcu,
    cartQty: Math.ceil(unitPcs / moq),
    itemQty,
    moqnum: moq,
    pcs: unitPcs,
    unpackFlag: packFlag,
  });
  if (addRes.success) {
    if (!addRes.data.success) {
      message.error(addRes.data.message);
      return;
    }

    const newData = state.dataSource.map((item, itemIndex) => ({
      ...item,
      userCart: index === itemIndex ? true : item.userCart,
      cartItemQty: index === itemIndex ? itemQty : item.cartItemQty,
      pcs:
        index === itemIndex
          ? inventoryCal(itemQty, moq, item.packspec, item.saleUom, item.saleUomDesc)
          : item.pcs,
    }));

    dispatch('updateState')({
      dataSource: newData,
      key: index, //标识当前加车的行数据
      isSuccess: true,
      buyTipVisible: true,
    });
    // ();
    eventBus.emit(eventBus.type.UPDATE_CART_COUNT);
    setTimeout(() => {
      dispatch('updateState')({ buyTipVisible: false, key: null });
    }, 3000);
  }
};
/**
 *
 * 加车case: （正常情况下出货量为起订量的整数倍，不足时向上取整）
 * 1.正常情况： 直接加车
 * 2.特殊情况（库存量 < 起订量 && 需求量 < 起订量）:
 *     a.允许拆包： 出货量为实际需求数量
 *     b.不允许拆包： 提示用户不支持拆散
 * 3.库存不足（库存量 < 出货量）：
 *     a.允许拆包： 提示用户是否需要拆散，需要，加车
 *     b.不允许拆包： 提示库存不足
 */
const addCart = async (
  imitm,
  itemId,
  ibmcu,
  inventory,
  moq,
  itemQty,
  packspec,
  index,
  dispatch,
  state,
  saleUom,
  saleUomDesc,
) => {
  /**
   * ibmcu：      仓别
   * inventory：  库存量
   * itemQty ：   需求量
   * moq ：       起订量
   * pcs：        出货量
   * saleUom        包装单位
   */
  const pcs = inventoryCal(itemQty, moq, packspec, saleUom, saleUomDesc);
  const unitPcs = parseInt(pcs[0].replace(/,/g, ''));

  // 特殊情况
  let isPack = false;
  // 是否库存不足（库存<出货量时）
  let isUnderstock = false;

  // 需要拆包的特殊情况
  if (itemQty < moq && inventory < moq) {
    isPack = true;
  }
  // 库存小于出货量并且大于实际需求量, 判断是否需要拆包
  if (inventory < unitPcs && inventory >= itemQty) {
    isUnderstock = true;
  }

  if (isPack || isUnderstock) {
    // 判断是否可以拆包
    const packRes = await pack({ imitm, itemId, spcomv: ibmcu });
    if (packRes && packRes.success) {
      // 不允许拆包
      if (!generatorObject(packRes.data).data) {
        message.error('此商品不支持拆散出货');
        dispatch('updateState')({ inventoryTipVisible: true, key: index });
        setTimeout(() => {
          dispatch('updateState')({ inventoryTipVisible: false, key: null });
        }, 3000);
        return;
      }
      if (isPack || isUnderstock) {
        save(imitm, itemId, ibmcu, itemQty, moq, itemQty, 'Y', index, dispatch, state);
      }
    }
  } else {
    save(imitm, itemId, ibmcu, unitPcs, moq, itemQty, 'N', index, dispatch, state);
  }
};
/**
 * 收藏夹加车结束
 */

// 需要拆包的特殊情况
const getSpecialShouldCheck = (inventory, moq, itemQty) => {
  return itemQty < moq && inventory < moq && inventory >= itemQty;
};

// 库存不足时的拆包
const getStockoutShoulePack = (inventory, moq, itemQty) => {
  /*
   * inventory：  库存量
   * itemQty ：   需求量
   * moq ：       起订量
   * pcs：        出货量
   */
  const maxMul = Math.ceil(itemQty / moq);
  const pcs = maxMul * moq;
  return inventory < pcs && inventory >= itemQty;
};

// 商品搜索列表页面专用 比较输入的需求量除以起订量 或者最小包装量是否为整数  如果是整数 则需要拆包  不是整数 需要拆包   因为99%配置起订量为最小包装数量  1%配置起订量小于最小包装数量
const getSearchPageShouldPack = (itemQty, packspec, moq) => {
  let packspecArr = packspec
    ? packspec.split('<BR />').filter((item) => asserts.isExist(item))
    : [];
  let minPackSpecItem = packspecArr.length ? packspecArr[0] : null;
  let minPackSpecItemArr = minPackSpecItem ? minPackSpecItem.split('/') : [];
  let minPackSpecNum = minPackSpecItemArr.length ? minPackSpecItemArr[0] : 0;
  let isInt =
    Number.isInteger(maths.div(itemQty || 0, Number(minPackSpecNum) || 0)) ||
    Number.isInteger(maths.div(itemQty || 0, Number(moq) || 0));
  return !isInt;
};

// 拆包结果
const packCheck = async (imitm, itemId, ibmcu) => {
  const res = await pack({ imitm, itemId, spcomv: ibmcu });
  if (res.success) {
    const result = generatorObject(res.data);
    if (!result.success) {
      message.error(result.message);
      return;
    }
    return result.data;
  }
  return false;
};

const saveToCart = async (
  imitm,
  itemId,
  ibmcu,
  moq,
  itemQty,
  pcs,
  scAttribute,
  scOrderMoq,
  scOrderMoqnum,
  scMoq,
  scMoqnum,
  scDay,
  scRemark,
  scDelivery,
  scMargin,
  scDeliveryDay,
  packFlag, //是否需要拆包
  callSource,
  stockCodeList,
  cartPack,
) => {
  const params = {
    imitm,
    itemId,
    spcomv: ibmcu,
    cartQty: Math.ceil(pcs / moq),
    itemQty, // 不管是否拆散都以输入的值为准加车
    // itemQty: pcs,
    // itemQty: Math.ceil(itemQty / moq) * moq, // todo 2022/03/24 受销售单位影响  起订量*需求数量  之前是直接取itemQty
    moqnum: moq,
    pcs, // 起订量的整数倍 支数
    unpackFlag: packFlag ? 'Y' : 'N',
    scAttribute,
    scOrderMoq,
    scOrderMoqnum,
    scMoq,
    scMoqnum,
    scDay,
    scRemark,
    scDelivery,
    scMargin,
    scDeliveryDay,
    callSource,
    stockCodeStr: asserts.isArray(stockCodeList) ? stockCodeList.join(',') : null,
    cartPack: JSON.stringify(cartPack),
  };
  return await addToCart(params);
};

//自定义单价加车
const saveSalesUomToCart = async (
  imitm,
  itemId,
  ibmcu,
  saleUom,
  saleUomMoqnum,
  cartItemQty,
  pcs,
  scAttribute,
  scOrderMoq,
  scOrderMoqnum,
  scMoq,
  scMoqnum,
  scDay,
  scRemark,
  scDelivery,
  scMargin,
  scDeliveryDay,
  packFlag, //是否需要拆包
  callSource,
  stockCodeList,
) => {
  const params = {
    imitm,
    itemId,
    spcomv: ibmcu,
    cartQty: cartItemQty,
    itemQty: pcs, // 已经乘过了
    moqnum: null,
    saleUom,
    saleUomMoqnum,
    pcs,
    unpackFlag: packFlag ? 'Y' : 'N',
    scAttribute,
    scOrderMoq,
    scOrderMoqnum,
    scMoq,
    scMoqnum,
    scDay,
    scRemark,
    scDelivery,
    scMargin,
    scDeliveryDay,
    callSource,
    stockCodeStr: asserts.isArray(stockCodeList) ? stockCodeList.join(',') : null,
  };
  return await addToCart(params);
};

export {
  addCart,
  getSpecialShouldCheck,
  getStockoutShoulePack,
  getSearchPageShouldPack,
  packCheck,
  saveToCart,
  saveSalesUomToCart,
};
